query PlatformMenuItemsList(
  $page: Int
  $rowsPerPage: Int
  $filter: PlatformMenuItemsFilterInput
) {
  platformMenuItems(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    nodes {
      id
      index
      label
      linkType
      href
      targetType
      targetId
      targetTitle
      visibilityConditions {
        userType
        countries {
          type
          countryCodes
        }
        applicationPlatforms {
          type
          platforms
        }
      }
      targetUrl
      publishAt
    }
    count
  }
}
